import type { IFilterChoiceItem } from '@/modules/universalStats/types/IFilterChoiceItem'

/** Элемент дерева GET /api/qualitycontrol/standard/ (в т.ч. depth=point) */
export interface IQualityControlStandardTreeItem {
  id: string
  label: string
  children?: IQualityControlStandardTreeItem[]
}

export function mapQualityControlTreeToFilterChoices(
  items: IQualityControlStandardTreeItem[],
): IFilterChoiceItem[] {
  return items.map(item => ({
    id: item.id,
    label: item.label,
    children: item.children?.length
      ? mapQualityControlTreeToFilterChoices(item.children)
      : [],
  }))
}
